"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
tslib_1.__exportStar(require("./components/Dialog/index"), exports);
var index_1 = require("./components/Dialog/index");
exports.default = index_1.Dialog;
//# sourceMappingURL=Dialog.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/office-ui-fabric-react/lib/Dialog.js
// module id = 944
// module chunks = 0